import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, label }) => (
  <div className="flex items-center gap-3 mb-5" data-testid={`eyebrow-${index}`}>
    <span className="font-mono text-xs tracking-[0.25em] text-burnt">{index}</span>
    <span className="h-px w-10 bg-tan/50" />
    <span className="font-mono text-xs tracking-[0.25em] text-tan">{label}</span>
  </div>
);
